module.exports = __webpack_public_path__ + "img/sparkle-3.0fd84a37.svg";